import { createStyles, Stack } from '@mantine/core';
import type { ClassifierCategory, PolicyRuleOut } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { getPIIClassifierLabel } from './utils';

const useStyles = createStyles((theme) => ({
	root: {
		border: `1px solid ${theme.other.getColor('border/secondary/default')}`,
		background: theme.other.getColor('surface/primary/default'),
		borderRadius: theme.radius.md,
		gap: 0,
	},
	container: {
		padding: theme.spacing.sm,
		gap: 0,
		'&:not(:last-child)': {
			borderBottom: `1px solid ${theme.other.getColor('border/secondary/default')}`,
		},
	},
}));

export default function PiiClassifier({ rule }: { rule: PolicyRuleOut }) {
	const { classes } = useStyles();

	return (
		<Stack className={classes.root}>
			<Stack className={classes.container}>
				<Text size="sm" weight="semibold">
					PII classifier
				</Text>
				<Text size="xs" color="text/secondary/default">
					Automatically scans and identifies sensitive fields
				</Text>
			</Stack>
			<Stack className={classes.container}>
				{rule.classifiers?.map((classifier: ClassifierCategory) => (
					<Text key={classifier} size="sm">
						• {getPIIClassifierLabel(classifier)}
					</Text>
				))}
			</Stack>
		</Stack>
	);
}
